import closingManagerService from "../service/closingManagerService"
import strings from "translate/language";
import { errorToast, successToast, unAuthorizedError } from "utils/httpClient";
import {  CLOSING_MANAGER_DETAILS, CLOSING_MANAGER_LIST, } from "../types";

export const getClosingManagerList = (item) => async (dispatch) => {
  try {
    const res = await closingManagerService.getClosingManagerList(item);
    if (res.data.status === 200) {
      dispatch({
        type: CLOSING_MANAGER_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: CLOSING_MANAGER_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getClosingManagerDetails = (item) => async (dispatch) => {
  try {
    const res = await closingManagerService.getClosingManagerDetails(item);
    if (res.data.status === 200) {
      dispatch({
        type: CLOSING_MANAGER_DETAILS,
        payload: res.data,
      });
    } else {
      dispatch({
        type: CLOSING_MANAGER_DETAILS,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};